export const portableTextWithInternalLinks = `
  ...,
  markDefs[]{ ..., _type == "link" => { ..., internalLink->{ _id, _type, "uid": uid[_key == $lang][0].value, } } }
`
